/* global modForm modUtils Modalytics */
import {
	initSuppressConversionPixel,
	blockDuplicateSubmissionSameHeapSessionId,
	switchFormLoadingState,
	switchFormSubmitState,
	validateRecaptchaResponse,
	processFormSubmitError,
	submitFormDataToFormsServiceApi,
	subscribeToNonTYPMutations,
	submitContractorFormDataToApi,
	initFormSubmitLoader,
	trackFormSubmissionFlow
} from '../../../helpers';

/**
 * Submit form action
 * @param {Object} formData - form data object
 */
export async function submitForm(formData) {
	initFormSubmitLoader();

	trackFormSubmissionFlow({ inSubmitForm: true });

	// set up observers as early as possible
	const observer = new MutationObserver(subscribeToNonTYPMutations.bind(modForm));
	observer.observe(modForm.mutationObserverTarget, modForm.mutationObserverConfig);
	// Fire callback before submitting
	if (modForm.opts.formSubmittingCallback && 'function' === typeof modForm.opts.formSubmittingCallback) {
		formData = modForm.opts.formSubmittingCallback(formData);
		trackFormSubmissionFlow({ formSubmittingCallbackCalled: true });
	}

	// Check that formData exists
	if (!formData) {
		trackFormSubmissionFlow({ noFormData: true });
		return;
	}

	initSuppressConversionPixel(formData);

	if (!modForm.opts.ignoreDuplicateSubmissionBlocker) {
		blockDuplicateSubmissionSameHeapSessionId(formData);
	}

	if (!modForm.preventDuplicateSubmission) {
		// Switch form to the loading & submitting state
		switchFormLoadingState(true);

		if (modForm.opts.showLoadingOverlay) {
			trackFormSubmissionFlow({ showLoadingOverlay: true });
			const $loader = document.getElementsByClassName('loader')[0];

			if ($loader) {
				$loader.classList.add('loader--visible');
				$loader.setAttribute('aria-hidden', 'false');
				$loader.focus();
				Modalytics.heap('track', ['Loader Overlay Initiated']);
			} else {
				Modalytics.heap('track', ['Loader Not Found']);
			}
			switchFormSubmitState('submitting');
		}
	}

	// Check for recaptcha token
	if (modForm.opts.validateRecaptcha) {
		const isHomeowner = modForm.opts.vertical !== 'contractor';
		const useFullDomain = !document.location.href.includes('modernize') && !document.location.href.includes('quinstreet.net');
		// Validate recaptcha for leads from WP Homeowner Pages or S3 without referrer
		if (isHomeowner && !modUtils.getCookie('original_referrer') && !modForm.opts.isOrganicPreferredMatch) {
			validateRecaptchaResponse(formData.recaptcha, function(isRecaptchaValid, errorMessage = '') {
				// Check that formData exists
				if (!isRecaptchaValid) {
					Modalytics.heap('track', [
						'Token Error', {
							token: 'reCaptcha',
							errorMessage: errorMessage
						}
					]);
					processFormSubmitError();
					return;
				}

				Modalytics.heap('track', [
					'Token Success',
					{
						token: 'reCaptcha'
					}
				]);

				// Submit data to API
				if (modForm.opts.useContractorApi) {
					submitContractorFormDataToApi(formData);
				} else {
					submitFormDataToFormsServiceApi(formData);
				}
			}, useFullDomain);
			return;
		}
	}

	if (!modForm.preventDuplicateSubmission) {
		// Submit data to API
		if (modForm.opts.useContractorApi) {
			submitContractorFormDataToApi(formData);
		} else {
			submitFormDataToFormsServiceApi(formData);
		}
	}
}
